// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { DdjDocument } from '@interfaces/document.interfaces';
import { DocumentsService } from '@services/documents.service';
import { UserTypes } from '../../interfaces/user.interfaces';
import { UserService } from '../user.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentResolver implements Resolve<DdjDocument> {
    constructor(
        private documentService: DocumentsService,
        private readonly router: Router,
        private readonly userService: UserService
    ) {}

    resolve(route: ActivatedRouteSnapshot): DdjDocument {
        //This call is broken for an unknown reason. The docId here states 'edit'
        const doc = this.documentService.getDocById(parseInt(route.params.docId));

        // deal is undefined if dealer doesn't have access to that deal
        // reroute dealer to their dashboard
        // check if deal is arrary as when a deal is not returned
        if (!doc) {
            if (
                route['_routerState'].url.includes('/documents') &&
                (this.userService.user.userType === UserTypes.Dealer || this.userService.user.userType === UserTypes.Internal)
            ) {
                this.router.navigate(['/dashboard', 'documents']);
            }

            //Returning the broken doc doesnt reroute twice to PendingChangesGuard.ts
            //checking to see if the route is in forms path.
            if (
                route['_routerState'].url.includes('/forms') &&
                (this.userService.user.userType === UserTypes.Dealer || this.userService.user.userType === UserTypes.Internal)
            ) {
                return doc;
            }

            this.userService.user.userType === UserTypes.Customer ? this.router.navigate(['/main', 'vehicles']) : this.router.navigate(['/dashboard', 'deals']);
            return doc;
        }

        return doc;
    }
}
